import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Switch from 'components/form/Switch';
import React from 'react';
import { useHistory } from 'react-router';

const StyledHeader = styled(Box)`
  display: flex;
  align-items: flex-start;
  text-decoration: none;
  color: inherit;
  padding: 8px 16px;
  cursor: pointer;
  &.expanded {
    .MuiSvgIcon-root {
      transition: transform 0.3s ease;
      transform: rotate(180deg);
    }
  }
`;

export default function ToggleAccordionHeader({
  title,
  eventKey,
  expanded,
  switchProps,
  onClick,
}) {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick(eventKey);
    }
  };

  return (
    <StyledHeader
      className={expanded && 'expanded'}
      onClick={onClick && handleClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Box display="flex" flex={1} alignItems="center">
        {switchProps && <Switch margin="none" {...switchProps} />}
        <Typography sx={{ mr: 'auto' }}>{title}</Typography>
        <ExpandMoreIcon />
      </Box>
    </StyledHeader>
  );
}
